import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { EMailAudit } from "./classes";

export const MAIL_PROVIDER_SERVICE = new InjectionToken<IMailProviderService>('MAIL_PROVIDER_SERVICE');

export interface IMailProviderService {
    mails$: Observable<EMailAudit[]>;
}

export const MSG_PROVIDER_SERVICE = new InjectionToken<IMsgProviderService>('MSG_PROVIDER_SERVICE');

export interface IMsgProviderService {
    msgFiles$: Observable<{ fileName: string, blobProvider: () => Observable<Blob> }[]>;
    setMsgFiles(files: { fileName: string, blobProvider: () => Observable<Blob> }[]);
}
